import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../api/api';
import { SUBMIT_ORDER_REQUEST, INITIATE_PAYMENT_REQUEST } from './choose-menu-types';
import { submitOrderSuccess, submitOrderFailure, initiatePaymentSuccess, initiatePaymentFailure } from './choose-menu-actions';

function submitOrderApi(orderData) {
	try {
		return api.post('custom-order', orderData)
			.catch((err) => {
				throw err;
			});
	} catch (err) {
		// console.error('Synchronous error in api.post:', err);
		throw err;
	}
}

function* submitOrderSaga(action) {
	try {
		const response = yield call(submitOrderApi, action.payload);
		yield put(submitOrderSuccess(response.data));
	} catch (error) {
		yield put(submitOrderFailure(error?.response?.data?.error || error.message || 'Could not place your order. Please try again later.'));
	}
}
function initiatePaymentApi(paymentData) {
  try {
    return api.post('initiate-payment', paymentData)
      .catch((err) => {
        // console.error('Promise rejection in api.post:', err);
        // throw err;
      });
  } catch (err) {
    // console.error('Synchronous error in api.post:', err);
    // throw err;
  }
}
function* initiatePaymentSaga(action) {
	try {
		const response = yield call(initiatePaymentApi, action.payload);
		yield put(initiatePaymentSuccess(response.data));
		// Redirect to payment_link if present
		if (response?.data?.payment_link) {
			window.location.href = response.data.payment_link;
		}
	} catch (error) {
		yield put(initiatePaymentFailure(error?.response?.data?.message || error.message || 'Payment initiation failed'));
	}
}

function* chooseMenuSaga() {
	yield takeLatest(SUBMIT_ORDER_REQUEST, submitOrderSaga);
  	yield takeLatest(INITIATE_PAYMENT_REQUEST, initiatePaymentSaga);
}
export default chooseMenuSaga;